import { KizenTypography } from '__app/typography';
import { unitDisplayTranslated } from 'pages/AutomationEngine/helpers';
import DraggableStepCard from '__pages/AutomationEngine/Engine/Steps/DraggableStepCard';

import {
  DelayStep,
  ValueOrigin,
} from 'pages/AutomationEngine/types/delay-types';
import { CardProps } from '../types';
import { TFunction } from 'react-i18next';

export const content = ({ step }: { step: CardProps['step'] }) =>
  step.description;

export const getDelayUnits = ({
  details: { minutes, hours, days, durationUnit },
}: DelayStep) =>
  durationUnit ||
  (minutes && 'minutes') ||
  (hours && 'hours') ||
  (days && 'days') ||
  'minutes';

export const getDelayDuration = ({
  details: { minutes, hours, days, variable, valueOrigin },
}: DelayStep) =>
  valueOrigin === ValueOrigin.automation_variable
    ? `‘${variable?.value}’`
    : minutes || hours || days;

export const getDescription = ({
  step,
  t,
}: {
  step: DelayStep;
  t: TFunction;
}) => {
  const units = getDelayUnits(step);
  const duration = getDelayDuration(step) || '';
  return t('Delay execution by {{duration}} {{unit}}', {
    duration: duration.toLocaleString(),
    unit: unitDisplayTranslated(t)[units][duration === 1 ? 'single' : 'plural'],
  });
};

export default function DelayCard({ type, step, ...others }: CardProps) {
  return (
    <DraggableStepCard {...others} type="automationDelay">
      <KizenTypography as="span">{content({ step })}</KizenTypography>
    </DraggableStepCard>
  );
}
